import api from "../../services/api";
import { types } from "../types/types";
import Constants from "../../services/constants";
import { hideLoaderAction, showLoaderAction } from "./loaderAction";
import { showToast } from "./toastAction";

const getPayments = (params = {}, setLoading) => async (dispatch) => {
    dispatch(showLoaderAction());
    if (setLoading) {
        setLoading(true);
    }
    const res = await api("get", Constants.END_POINT.PAYMENT_HISTORY, {}, params);
    if (res.success) {
        if (res.data) {
            dispatch({
                type: types.PAYMENT,
                payload: { data: res.data, pagination: res.paginationAndSort },
            });
        }
    }
    if (setLoading) {
        setLoading(false);
    }
    dispatch(hideLoaderAction());
};
const getPayment = (id, returnData) => async (dispatch) => {
    dispatch(showLoaderAction());
    const res = await api("get", Constants.END_POINT.GET_INVOICE + id);
    if (res.success) {
        if (res.data) {
            console.log("res",res);
            
            if (returnData) {
                returnData(res.data);
            }
        }
    }
    dispatch(hideLoaderAction());
};

export { getPayments, getPayment};
